/**
 * Action creator for loading a single account by uuid.
 *
 * Returns a react-fetching-library request descriptor — pair with
 * `useQuery` in the consuming feature. Pure function, no store
 * dependency. Mirrors the inline GET in legacy AccountEdit.jsx so
 * the request shape and path stay identical.
 *
 * Endpoint: GET /accounts/:uuid
 */
export const fetchAccountAction = ({ uuid }) => ({
  method: 'GET',
  endpoint: `/accounts/${uuid}`,
});
